import { render } from "./CarFaxRequest.vue?vue&type=template&id=e6599456&scoped=true&ts=true"
import script from "./CarFaxRequest.vue?vue&type=script&lang=ts"
export * from "./CarFaxRequest.vue?vue&type=script&lang=ts"

import "./CarFaxRequest.vue?vue&type=style&index=0&id=e6599456&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6599456"]])

export default __exports__